export const SUPPORT_AREAS = {
	expert: [
		{ value: 'LECTURE', label: 'Özel Ders' },
		{ value: 'QUESTION_SOLUTION', label: 'Soru Çözümü' }
	],
	guide: [
		{ value: 'LECTURE', label: 'Özel Ders' },
		{ value: 'GUIDANCE', label: 'Sınav Koçluğu' },
		{ value: 'QUESTION_SOLUTION', label: 'Soru Çözümü' }
	]
};

export const WORK_STATUS = [
	{ value: 'PUBLIC_SCHOOL', label: 'Devlet Okulu' },
	{ value: 'PRIVATE_SCHOOL', label: 'Özel Okul' },
	{ value: 'UNEMPLOYMENT', label: 'Çalışmıyorum' }
];

export const WORK_STATUS_MAP = {
	PUBLIC_SCHOOL: 'Devlet okulunda çalışıyorum',
	PRIVATE_SCHOOL: 'Özel okulda çalışıyorum',
	UNEMPLOYMENT: 'Çalışmıyorum'
};

export const EDUCATION_LEVELS = [
	{ value: 'primary', label: 'İlkokul' },
	{ value: 'secondary', label: 'Ortaokul' },
	{ value: 'high', label: 'Lise' },
	{ value: 'kpss', label: 'KPSS' },
	{ value: 'dgs', label: 'DGS' },
	{ value: 'ales', label: 'ALES' }
];

export const HIGH_SCHOOL_SUBJECTS = [
	{ value: 'turkish', label: 'Türkçe' },
	{ value: 'math', label: 'Matematik' },
	{ value: 'physics', label: 'Fizik' },
	{ value: 'chemistry', label: 'Kimya' },
	{ value: 'biology', label: 'Biyoloji' },
	{ value: 'social', label: 'Sosyal Bilgiler' },
	{ value: 'history', label: 'İnkılap Tarihi' },
	{ value: 'english', label: 'İngilizce' },
	{ value: 'geography', label: 'Coğrafya' },
	{ value: 'philosophy', label: 'Felsefe' },
	{ value: 'literature', label: 'Edebiyat' }
];

export const SUBJECTS_BY_LEVEL = {
	primary: [
		{ value: 'turkish', label: 'Türkçe' },
		{ value: 'math', label: 'Matematik' },
		{ value: 'life_science', label: 'Hayat Bilgisi' },
		{ value: 'science', label: 'Fen Bilgisi' },
		{ value: 'english', label: 'İngilizce' }
	],
	secondary: [
		{ value: 'turkish', label: 'Türkçe' },
		{ value: 'math', label: 'Matematik' },
		{ value: 'social', label: 'Sosyal Bilgiler' },
		{ value: 'history', label: 'İnkılap Tarihi' },
		{ value: 'science', label: 'Fen Bilgisi' },
		{ value: 'english', label: 'İngilizce' }
	],
	high: [
		{ value: 'turkish', label: 'Türkçe' },
		{ value: 'math', label: 'Matematik' },
		{ value: 'physics', label: 'Fizik' },
		{ value: 'chemistry', label: 'Kimya' },
		{ value: 'biology', label: 'Biyoloji' },
		{ value: 'history', label: 'Tarih' },
		{ value: 'geography', label: 'Coğrafya' },
		{ value: 'philosophy', label: 'Felsefe' },
		{ value: 'english', label: 'İngilizce' },
		{ value: 'literature', label: 'Edebiyat' }
	],
	kpss: [
		{ value: 'turkish', label: 'Türkçe' },
		{ value: 'math', label: 'Matematik' },
		{ value: 'history', label: 'Tarih' },
		{ value: 'geography', label: 'Coğrafya' }
	],
	dgs: [
		{ value: 'turkish', label: 'Türkçe' },
		{ value: 'math', label: 'Matematik' }
	],
	ales: [
		{ value: 'turkish', label: 'Türkçe' },
		{ value: 'math', label: 'Matematik' }
	]
};
